import axios from 'axios';
import getJWT from './token';

let api = `https://api.${process.env.REACT_APP_BASE_URL || "lea.commerce-ims.com"}`;


const operationsHelpers = {

    getBuilds: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/warehouse/builds`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers, params: payload });
            const builds = res.data;

            const builds_array = Object.keys(builds).map((key) => builds[key]);
            builds_array.forEach((builds, index) => {
                builds['id'] = index;
            });

            return builds_array;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    getPackagesOnTruck: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/warehouse/trucks`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers, params: payload });
            const packages = res.data;

            const packages_array = Object.keys(packages).map((key) => packages[key]);
            packages_array.forEach((packages, index) => {
                packages['id'] = index;
            });
            
            return packages_array;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        }
    },

    getWorkers: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/warehouse/workers`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.get(url, { headers, params: payload });
            console.log('res', res)
            const workers = res.data;

            return workers;
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    insertWorker: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/warehouse/workers/add`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.post(url, payload, { headers });
            if (res.status === 204) {
                return {
                    success: true
                };
            } else {
                return {
                    success: false,
                    message: "Failed to insert Worker!"
                };
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },

    updateWorker: async (payload, company_id, token) => {
        const userToken = await getJWT(token);
        const url = `${api}/warehouse/workers/update`;

        const headers = {
            company_id: company_id[0].toUpperCase() + company_id.substring(1),
            Authorization: `Bearer ${userToken}`
        };

        try {
            const res = await axios.put(url, payload, { headers });
            if (res.status === 204) {
                return {
                    success: true
                };
            } else {
                return {
                    success: false,
                    message: "Failed to update worker!"
                };
            };
        } catch (error) {
            console.log(JSON.stringify(error.message));
            return {
                success: false,
                error
            };
        };
    },
};

export default operationsHelpers;